// @flow
import React from "react";
import { Form } from "react-bootstrap";

/**
 * Componente para los tipos de disposición
 *
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.changeLayoutType - Función para cambiar el tipo de disposición
 * @param {String} props.layoutType - Tipo de disposición
 * @param {Object} props.layoutConstants - Constantes de disposición
 * @returns {JSX.Element} Componente de React
 */
const LayoutTypes = ({ changeLayoutType, layoutType, layoutConstants }) => {
  return (
    <>
      <h5>Disposición</h5>

      <hr className="mt-1" />

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          onChange={(e) => changeLayoutType(e.target.value)}
          name="layout-type"
          value={layoutConstants.LAYOUT_VERTICAL}
          id="vertical-layout"
          checked={layoutType === layoutConstants.LAYOUT_VERTICAL}
        />
        <Form.Check.Label htmlFor="vertical-layout">
          Disposición Vertical
        </Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          onChange={(e) => changeLayoutType(e.target.value)}
          name="layout-type"
          value={layoutConstants.LAYOUT_HORIZONTAL}
          id="horizontal-layout"
          checked={layoutType === layoutConstants.LAYOUT_HORIZONTAL}
        />
        <Form.Check.Label htmlFor="horizontal-layout">
          Disposición Horizontal
        </Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          onChange={(e) => changeLayoutType(e.target.value)}
          name="layout-type"
          value={layoutConstants.LAYOUT_DETACHED}
          id="detached-layout"
          checked={layoutType === layoutConstants.LAYOUT_DETACHED}
        />
        <Form.Check.Label htmlFor="detached-layout">
          Diseño Desacoplado
        </Form.Check.Label>
      </Form.Check>

      <Form.Check className="form-check form-switch mb-1">
        <Form.Check.Input
          type="radio"
          onChange={(e) => changeLayoutType(e.target.value)}
          name="layout-type"
          value={layoutConstants.LAYOUT_FULL}
          id="full-mode-layout"
          checked={layoutType === layoutConstants.LAYOUT_FULL}
        />
        <Form.Check.Label htmlFor="full-mode-layout">
          Diseño Completo
        </Form.Check.Label>
      </Form.Check>
    </>
  );
};

export default LayoutTypes;
